import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useTranslation } from 'react-i18next';
import { FadeTransition } from './Transitions';

interface RemovalConfirmationDialogProps {
    isOpen: boolean;
    handleClose(): void;
    handleRemove(): Promise<void>;
    dialogTitle: React.ReactNode;
    dialogContent?: React.ReactNode;
    cancelButtonText?: React.ReactNode;
    deleteButtonText?: React.ReactNode;
}

const RemovalConfirmationDialog = ({
    dialogTitle,
    dialogContent,
    isOpen,
    handleClose,
    handleRemove,
    cancelButtonText,
    deleteButtonText
}: RemovalConfirmationDialogProps) => {
    const { t } = useTranslation();
    const [isRemoving, setIsRemoving] = useState(false);
    const onRemoveClick = async () => {
        try {
            setIsRemoving(true);
            await handleRemove();
        } finally {
            setIsRemoving(false);
        }
    };

    return (
        <Dialog
            open={isOpen}
            TransitionComponent={FadeTransition}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle id="alert-dialog-slide-title">{dialogTitle}</DialogTitle>
            {dialogContent
                ? (
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            {dialogContent}
                        </DialogContentText>
                    </DialogContent>
                ) : null}
            <DialogActions>
                <Button onClick={handleClose} variant='outlined' color="primary">
                    {cancelButtonText || t('Cancel')}
                </Button>
                <Button onClick={onRemoveClick} disabled={isRemoving} variant='outlined' color="secondary">
                    {deleteButtonText || t('Remove')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RemovalConfirmationDialog;
